import { BadgePosition } from "./badge-collision";

/**
 * Samples points along an SVG path at specified positions (0-1).
 * Uses a simple approach: create an invisible SVG path element in memory,
 * and use getPointAtLength to sample along it.
 */
export function samplePathPoints(
  svgPath: string,
  positions: number[],
): BadgePosition[] {
  if (typeof document === "undefined") {
    return [];
  }

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", svgPath);
  svg.append(path);

  const totalLength = path.getTotalLength();
  const points: BadgePosition[] = [];

  for (const position of positions) {
    const length = totalLength * position;
    const point = path.getPointAtLength(length);
    points.push({ x: point.x, y: point.y });
  }

  return points;
}
